import { ClientOptions } from 'graphql-ws'
import { DdLogs } from '@/modules/datadog'

import { ENV_STORAGE_KEY, EnvironmentStages, getEnvStage, RootStore } from '../models'
import * as Storage from '../utils/storage'
import { isEmpty } from 'lodash'
import { LoggerContexts, extendLogger } from './logger'
import { globalConnectionParams } from '../models/GlobalConnectionParams'
import { SubscriptionClient, WebSocketConnectionState } from '../models/network/SubscriptionClient'
import { createHttpClient } from 'mst-gql'
import { getBaseUrls } from '@/models/getBaseUrls'

const logger = extendLogger(LoggerContexts.RootStore)

export const getSubscriptionClientOptions = async (rootStore: RootStore | undefined) => {
  const { stage, pathPrefix } = await getEnvStage()

  const { baseUrls, baseWebSocketUrls } = getBaseUrls({ pathPrefix })

  const baseURL = baseUrls[stage]
  logger.debug('baseURL', baseURL)
  const baseWebSocketURL = baseWebSocketUrls[stage]
  logger.debug('baseWebSocketURL', baseWebSocketURL)

  const subscriptionClientOptions: ClientOptions = {
    // ClientOptions:
    //   https://github.com/apollographql/subscriptions-transport-ws

    // how long the client should wait in ms for a keep-alive message from the server (default 30000 ms),
    // this parameter is ignored if the server does not send keep-alive messages.
    // This will also be used to calculate the max connection time per connect/reconnect
    // timeout: 5000,

    // object that will be available as first argument of onConnect (in server side), if passed a function
    // - it will call it and send the return value, if function returns as promise
    // - it will wait until it resolves and send the resolved value.
    connectionParams: () => {
      logger.debug('connectionParams', globalConnectionParams)
      const { token } = globalConnectionParams
      const headers = token ? { authorization: `bearer ${token}` } : {}
      logger.debug('connectionParams headers', headers)
      return { headers }
    },

    on: {
      connecting: () => {
        logger.debug('ClientOptions.on(connecting)')
        rootStore?.network.setWebSocketState(WebSocketConnectionState.connecting)
      },
      connected: (event: unknown) => {
        logger.debug('ClientOptions.on(connected)', event)
        rootStore?.network.setWebSocketState(WebSocketConnectionState.connected)
      },
      closed: (event) => {
        logger.debug('ClientOptions.on(closed)', event)
        DdLogs.error(`Subscription client closed ${JSON.stringify(event)}`)
        // if closed with the `4403: Forbidden` close event
        // the client or the server is communicating that the token
        // is no longer valid and should be therefore refreshed
        // if (event.code === 4403) shouldRefreshToken = true
        rootStore?.network.setWebSocketState(WebSocketConnectionState.closed)
      },
      error: (event) => {
        DdLogs.error(`Subscription client error ${JSON.stringify(event)}`)
        logger.error(`error ${event}`)
      }
    },
    lazy: true,
    // connectionCallback: (errors: Error[], result?: any) => {
    //   if (errors) {
    //     logger.error('connectionCallback error', errors)
    //     return
    //   }
    //   logger.log('connectionCallback result', result)
    // },
    url: baseWebSocketURL
  }

  const gqlWsClient = new SubscriptionClient(subscriptionClientOptions)

  return {
    env: {
      baseURL,
      baseWebSocketURL,
      kinesisGameEventCommandsUrl: `${baseURL}/kinesis/game-events`,
      stage,
      // if we don't have http mst-gql will only use WebSockets
      gqlHttpClient: createHttpClient(`${baseURL}/graphql`),
      //   const customFetch = (uri, options) => {
      //   const { header } = Hawk.client.header(
      //     "http://example.com:8000/resource/1?b=1&a=2",
      //     "POST",
      //     { credentials: credentials, ext: "some-app-data" }
      //   );
      //   options.headers.Authorization = header;
      //   return fetch(uri, options);
      // };

      // const link = new HttpLink({ fetch: customFetch });
      // gqlHttpClient: createHttpClient(`${baseURL}/graphql`, { fetch: customFetch }),
      // @NOTE: This is an Anthony hack to make GraphQL subscriptions work locally until NestJs 9.0 is released.
      // @TODO: One day NestJs + Apollo 3.0 + Graphql-Ws will come to life and we can consolidate this to the latest graphql-ws
      // gqlWsClient: legacyGqlClient,
      graphqlWsClient: gqlWsClient,
      socket: WebSocket
    }
  }
}
